import { Box, Card, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { loadTextFromFile } from "../../../../../utils/loadTextFromFile";


export default function MobileTherapistProfile({ therapist }) {

    const [biography, setBiography] = useState("");
    const [biographyError, setBiographyError] = useState(null);

    useEffect(
        function () {
          loadTextFromFile({ fileName: therapist.biography , dir:'biographies'})
            .then((txt) => {
              setBiography(txt);
              setBiographyError(null);
            })
            .catch((e) => {
              setBiographyError(e);
              setBiography("");
            });
        },
        [therapist.biography],
      );
    
    
    return(
        <Card
  sx={{
    maxWidth: 900,
    borderRadius: 3,
    boxShadow: 4,
    p: 3
  }}
>
  <Box
    sx={{
      float: "left",
      width: 'fullwidth',
      mr: 3,
      mb: 2,
      p: 2,
      textAlign: "center"
    }}
  >
    <Box
      component="img"
      src={therapist.image}
      alt={`${therapist.name}'s profile`}
      sx={{
        width: 140,
        height: 140,
        borderRadius: "50%",
        objectFit: "cover",
        border: "4px solid white",
        boxShadow: 2,
        mb: 2,
      }}
    />

    <Typography variant="h6" fontWeight="bold">
      {therapist.fullname}
    </Typography>

    <Typography variant="subtitle2" color="text.secondary">
      {therapist.specialty}
    </Typography>

    <Typography variant="subtitle2" color="text.secondary">
      {therapist.subspecialty}
    </Typography>
  </Box>

  <Typography variant="h6" fontWeight="bold" gutterBottom textAlign="left">
    Βιογραφικό
  </Typography>

  <Typography
    variant="body1"
    sx={{
      lineHeight: 1.8,
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      textAlign: "left",
      mb:5
    }}
  >
    {biography}
  </Typography>
  {biographyError && <Typography color="error">{biographyError.message}</Typography>}

  <Box sx={{ clear: "both" }} />
</Card>
    )
}